export const LATITUDE_OFFSET = 90;
export const Z_INDEX_SCALE = 100;
